/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { ContactUpload } from './ContactUpload.js';
import {
    ContactUploadFromJSON,
    ContactUploadFromJSONTyped,
    ContactUploadToJSON,
} from './ContactUpload.js';

/**
 * 
 * @export
 * @interface CreateScorecardResponseData
 */
export interface CreateScorecardResponseData {
    /**
     * 
     * @type {number}
     * @memberof CreateScorecardResponseData
     */
    id?: number;
    /**
     * 
     * @type {Array<ContactUpload>}
     * @memberof CreateScorecardResponseData
     */
    uploads?: Array<ContactUpload>;
}

/**
 * Check if a given object implements the CreateScorecardResponseData interface.
 */
export function instanceOfCreateScorecardResponseData(value: object): boolean {
    return true;
}

export function CreateScorecardResponseDataFromJSON(json: any): CreateScorecardResponseData {
    return CreateScorecardResponseDataFromJSONTyped(json, false);
}

export function CreateScorecardResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateScorecardResponseData {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'uploads': json['uploads'] == null ? undefined : ((json['uploads'] as Array<any>).map(ContactUploadFromJSON)),
    };
}

export function CreateScorecardResponseDataToJSON(value?: CreateScorecardResponseData | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'uploads': value['uploads'] == null ? undefined : ((value['uploads'] as Array<any>).map(ContactUploadToJSON)),
    };
}

